module.exports = __webpack_public_path__ + "src/images/measurements/lineColor.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/lineColor.jpg
// module id = 1151
// module chunks = 0